module.exports = __webpack_public_path__ + "img/shoping_bag_white.61fac508.svg";